import { PrizmLanguagePaginator } from '../../interfaces';

export const PRIZM_RUSSIAN_PAGINATOR: PrizmLanguagePaginator = {
  paginator: {
    linesShown: 'Показано строк:',
    fromText: 'из',
    linesOnPage: 'Строк на странице',
    moreButtonLabel: 'Показать ещё',
  },
};
